import { render, staticRenderFns } from "./AdditionalData.vue?vue&type=template&id=18446b67&"
import script from "./AdditionalData.vue?vue&type=script&lang=js&"
export * from "./AdditionalData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports